export default {"src":"/_next/static/media/refer-a-friend.6059a0ad.svg","height":467,"width":500};